import createViewer from './viewer'

let gallery = null
let timer = null
let retry = 500

function init (el) {
  if (!el.querySelectorAll('img').length && retry) {
    clearInterval(timer)
    timer = setInterval(() => {
      init(el)
      retry--
      if (!retry) {
        clearInterval(timer)
      }
    }, 20)
  } else {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
    if (gallery) gallery.destroy()
    gallery = createViewer(el)
  }
}

export default {
  bind (el) {
    init(el)
  },
  update (el) {
    // if (gallery) {
    //     // gallery.update() // 更新存在bug，分页器的位置异常
    //      try {
    //         gallery.destroy()
    //         gallery = null
    //         timer = null
    //         retry = 50
    //         init(el)
    //     } catch (e) {}
    // } else {
    //     init(el)
    // }
    // debugger
    try {
      gallery.destroy()
      gallery = null
      timer = null
      retry = 50
    } catch (e) {
    } finally {
      init(el)
    }
  },
  unbind () {
    if (gallery) {
      gallery.destroy()
      gallery = null
      timer = null
      retry = 50
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/directives/preview.js